var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBot = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4 12C4 7.58173 7.58173 4 12 4C16.4183 4 20 7.58173 20 12V18.6667H4V12ZM9.10015 10.7832C9.10015 11.4551 8.5554 11.9999 7.88341 11.9999C7.21142 11.9999 6.66667 11.4551 6.66667 10.7832C6.66667 10.1112 7.21142 9.56642 7.88341 9.56642C8.5554 9.56642 9.10015 10.1112 9.10015 10.7832ZM16.1168 11.9999C16.7888 11.9999 17.3336 11.4551 17.3336 10.7832C17.3336 10.1112 16.7888 9.56642 16.1168 9.56642C15.4448 9.56642 14.9001 10.1112 14.9001 10.7832C14.9001 11.4551 15.4448 11.9999 16.1168 11.9999Z",
  fill: "white"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.333 13.4502C22.8058 13.4502 23.9997 14.6441 23.9997 16.1169V18.7835H21.333V13.4502Z",
  fill: "white"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M0 16.1169C0 14.6441 1.19391 13.4502 2.66667 13.4502V18.7835H0V16.1169Z",
  fill: "white"
})));
export { SvgBot as ReactComponent };
export default __webpack_public_path__ + "6c6cc629108a5e854b4a27d924e872f9.svg";